import { memo } from "react";

import { Transition } from "@headlessui/react";

import { LoadingOverlayView } from "@components/LoadingOverlay/LoadingOverlay.view";
import { STOREFRONT_TRANSITION_EASING } from "@tablescape/constants";
import { tw } from "classnames";

type Props = {
  show: boolean;
};

const styles = {
  transition: {
    className: tw("absolute", "top-0", "bottom-0", "left-0", "right-0"),
    enter: tw(
      "transition-opacity",
      STOREFRONT_TRANSITION_EASING,
      "duration-150"
    ),
    enterFrom: tw("opacity-0"),
    enterTo: tw("opacity-100"),
    leave: tw(
      "transition-opacity",
      STOREFRONT_TRANSITION_EASING,
      "duration-150"
    ),
    leaveFrom: tw("opacity-100"),
    leaveTo: tw("opacity-0"),
  },
};

const LoadingOverlayBase = ({ show }: Props) => {
  return (
    <Transition show={show} {...styles.transition}>
      <LoadingOverlayView />
    </Transition>
  );
};

export const LoadingOverlay = memo(LoadingOverlayBase);
